const selectors = {
  search: "#ingredients-search",
  select: '.recipe-search-form select',
  clear: '.recipe-search-clear',
};

let route = {
  init() {
    if (!document.querySelector(selectors.search)) {
      return;
    }

    let script = document.createElement("script");
    let link = document.createElement("link");

    link.rel = "stylesheet";
    link.href =
      "https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css";

    script.src =
      "https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js";

    document.body.appendChild(script);
    document.body.appendChild(link);

    let select2Interval = setInterval(function () {
      if ($.fn.select2) {
        clearInterval(select2Interval);

        route.initIngredientsSearch();
      }
    }, 50);
  },

  initIngredientsSearch() {
    let dropdown = $(selectors.search);
    let form = document.querySelector('#recipe-search-form')
    let placeholder = dropdown.attr('placeholder')

    if (! placeholder) {
      placeholder = dropdown.attr('aria-placeholder');
    }

    form.classList.remove('opacity-0')

    $(selectors.select).on('change', function() {
      let $this = $(this);
      let $clear = $this.next('button')

      console.log($this, $this.val(), this.value)

      $clear[$this.val() ? 'show' : 'hide']()
    });

    $(selectors.clear).on('click', function() {
      let target = $(this.getAttribute('aria-controls'));

      $(target).val(null);

      this.style.display = 'none';
    });

    dropdown.select2({
      dropdownParent: $('.recipe-dropdown-container'),
      maximumSelectionLength: 3,
      placeholder,
    });
  },
};

export default route;



// WEBPACK FOOTER //
// ./scripts/routes/home.js